export default __webpack_public_path__ + "static/media/hammer-2.d7d34294.png";